import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import ResponsiveCarousel from './responsivecarousel';
import DrawRectangle from './drawrectangle';

gsap.registerPlugin(ScrollTrigger);

// used for the mobile app page animations
function MobileApp() {
  function observe() {
    $('#mobileapp-modal-video').on('shown.bs.modal', () => {
      $('#modal-video-source').get(0).play();
    });
    $('#mobileapp-modal-video').on('hidden.bs.modal', () => {
      $('#modal-video-source').get(0).pause();
    });
  }

  const minuteVideoButton = document.getElementById('btnPlayVid2');
  if (minuteVideoButton) {
    minuteVideoButton.addEventListener('click', (e) => {
      const button = e.currentTarget;
      if (button) {
        button.style.visibility = 'hidden';
        const video = button.previousElementSibling;
        if (video.tagName === 'VIDEO') {
          video.load();
          video.setAttribute('controls', 'controls');
          video.play();
        }
      }
    });
  }

  const nav = document.getElementById('dnnbootsterNav');
  const bg = document.getElementById('mobile-magic-bg');
  const intro = document.getElementById('mobileapp-intro');
  const introText = document.getElementById('mobileapp-intro-text');
  const introImg = document.getElementById('mobileapp-intro-img');
  const mobilize = document.getElementById('sectionGetMobilized');
  const mobilizeTitle = document.getElementById('get-mobilized-title');
  const mobilePage = document.getElementById('mobileapp');

  // originally in the css for all pages, only want this for this page
  if (mobilePage) {
    const footer = document.getElementById('marines-footer');
    footer.style.zIndex = 1;
  }

  if (nav && bg) {
    gsap.to(bg, {
      yPercent: -15,
      ease: 'none',
      scrollTrigger: {
        trigger: '.magic-parallax',
        scrub: true,
      },
    });
  }

  if (intro && introText && introImg) {
    const tlSlide1 = gsap.timeline({
      delay: 1,
    });

    tlSlide1
      .fromTo(introText, 0.7, {
        opacity: 0,
        x: 80,
        ease: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
      }, {
        opacity: 1,
        x: 0,
      })
      .fromTo(introImg, 0.6, {
        delay: 0.4,
        opacity: 0,
        scaleX: 0,
        ease: 'cubic-bezier(0.0, 0.0, 0.2, 1)',
      }, {
        opacity: 1,
        scaleX: 1,
      });
  }

  if (mobilize && mobilizeTitle) {
    const tlSlide3 = gsap.timeline({
      delay: 1,
    });
    tlSlide3.fromTo(mobilizeTitle, 0.6, {
      opacity: 0,
      y: 35,
      ease: 'cubic-bezier(0.0, 0.0, 0.2, 1)',
    }, {
      opacity: 1,
      y: 0,
    });
  }

  function init() {
    DrawRectangle();
    ResponsiveCarousel({
      container: 'photos-rotator',
      prev: 'photos-rotator-prev',
      next: 'photos-rotator-next',
      prevMobile: 'pager-mobile-previous',
      nextMobile: 'pager-mobile-next',
      indicators: 'photos-rotator-indicators',
      autorotate: false,
    });
    observe();
  }

  init();
}

export default MobileApp;
